import React, { Component } from 'react';
import Actions from '../../../actions/actions';

export class MaintenancePage extends Component {
  componentDidMount() {
    setTimeout(() => {
      Actions.setRoute('/new/proposal');
      Actions.setView({ page: 'newProposal' });
    }, 5 * 60 * 1000);
  }

  render() {
    return (
      <div className={'qa-maintenance'}>
        <h3>
          <span className="animated-ellipsis">We are down for maintenance, please try again later</span>
        </h3>
      </div>
    );
  }
}
